import React from 'react';
import GameCard from '../../shared/GameCard';

const FlashcardGameCard = () => {
  return (
    <GameCard
      title="Fiszki"
      description="Ucz się słówek za pomocą fiszek. Obracaj karty, aby zobaczyć tłumaczenie i zaznaczaj, które słówka już znasz."
      imageUrl="/images/flashcard_game.png"
      imageAlt="Ucz się słówek za pomocą fiszek. Obracaj karty, aby zobaczyć tłumaczenie i zaznaczaj, które słówka już znasz."
      link="/study/flashcards"
    />
  );
};

export default FlashcardGameCard; 